"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardDataLoaderFactory = void 0;
// (C) 2021 GoodData Corporation
var util_1 = require("@gooddata/util");
var sdk_model_1 = require("@gooddata/sdk-model");
var constants_1 = require("./constants");
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var DashboardDataLoader = /** @class */ (function () {
    function DashboardDataLoader(workspace) {
        this.workspace = workspace;
        this.dashboardCache = new util_1.LRUCache({ maxSize: constants_1.DASHBOARD_CACHE_SIZE });
    }
    DashboardDataLoader.prototype.getDashboard = function (backend, ref) {
        var _this = this;
        var cacheKey = sdk_model_1.objRefToString(ref);
        var dashboard = this.dashboardCache.get(cacheKey);
        if (!dashboard) {
            dashboard = backend
                .workspace(this.workspace)
                .dashboards()
                .getDashboard(ref)
                .catch(function (error) {
                _this.dashboardCache.delete(cacheKey);
                throw error;
            });
            this.dashboardCache.set(cacheKey, dashboard);
        }
        return dashboard;
    };
    return DashboardDataLoader;
}());
/**
 * @internal
 */
exports.dashboardDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new DashboardDataLoader(workspace); });
//# sourceMappingURL=DashboardDataLoader.js.map